import notHandledHere from './notHandledHere';

export default {
    verb: 'didRemove',
    description: 'Trim the response and identify the record that was removed.',
    excludedNamespaceRelations: notHandledHere,
    //this is the actual logic:
    logic: remove
};

/**
 * Removes the deleted record from the response while retaining its ID.
 *
 * ActiveRecord uses `removedRecordId` to close a form only when that form is
 * showing the deleted record. This matters when socket events delete another
 * record of the same type while a user is editing.
 */
function remove({ context, data }) {
    const { namespace, relation, type } = context;
    return {
        namespace,
        relation,
        type,
        removedRecordId: data.id
    };
}
